<div
  class="card__experiencia"
  (click)="onClick()"
  [ngClass]="experienciaNivelClasse"
>
  <div class="experiencia__imagem">
    <div class="div__texto_tag" *ngIf="tag">
      <app-texto-tag
        [tag]="tag"
        [destaque]="destaque"
        [pageIndex]="true"
      ></app-texto-tag>
    </div>
    <img class="imagem" [src]="imagemSrc" />
  </div>
  <div class="experiencia__detalhes">
    <div class="detalhes__preco">
      <lovers-pontos
        [pontuacao]="preco"
        [minimo]="true"
        [exibirVoceTem]="false"
        [experienciaCard]="true"
      >
      </lovers-pontos>
    </div>
    <p class="detalhes__titulo">{{ titulo }}</p>
    <p class="detalhes__descricao">
      {{ descricao }}
    </p>
  </div>
  <div class="card__footer_color" [ngClass]="experienciaNivelClasse"></div>
</div>
